import { render, staticRenderFns } from "./Block2Creation.vue?vue&type=template&id=2d6f1559&scoped=true&"
import script from "./Block2Creation.vue?vue&type=script&lang=js&"
export * from "./Block2Creation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6f1559",
  null
  
)

export default component.exports